import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ReportsActionsModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('actions');
  const [formData, setFormData] = useState({
    reportType: 'performance',
    dateFrom: '',
    dateTo: '',
    includeCharts: true,
    includeAnalysis: true,
    aiInsights: false,
    autoSchedule: false
  });

  const actions = [
    { id: 'ai-report', icon: 'BarChart3', label: 'تقرير ذكي شامل', color: '#8B5CF6' },
    { id: 'performance', icon: 'TrendingUp', label: 'تقرير الأداء', color: '#10B981' },
    { id: 'financial', icon: 'DollarSign', label: 'تقرير مالي', color: '#F59E0B' },
    { id: 'comparison', icon: 'GitCompare', label: 'تقرير مقارنة', color: '#3B82F6' },
    { id: 'forecast', icon: 'Activity', label: 'تنبؤات ذكية', color: '#EC4899' },
    { id: 'schedule', icon: 'Calendar', label: 'جدولة تلقائية', color: '#06B6D4' }
  ];

  const templates = [
    { id: 'monthly', name: 'تقرير شهري', metrics: ['revenue', 'deals', 'clients'] },
    { id: 'quarterly', name: 'تقرير ربع سنوي', metrics: ['growth', 'performance', 'roi'] },
    { id: 'annual', name: 'تقرير سنوي', metrics: ['all', 'trends', 'forecast'] },
    { id: 'custom', name: 'تقرير مخصص', metrics: ['custom'] }
  ];

  const handleAction = (actionId) => {
    console.log('Report action:', actionId);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title="التقارير - الإجراءات والقوالب"
      footer={null}
      icon={null}
      iconColor={null}
    >
      <div className="space-y-6">
        <div className="flex gap-2 border-b border-border">
          <button
            onClick={() => setActiveTab('actions')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'actions' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الإجراءات
          </button>
          <button
            onClick={() => setActiveTab('templates')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'templates' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            القوالب
          </button>
          <button
            onClick={() => setActiveTab('settings')}
            className={`px-4 py-2 font-medium transition-colors ${
              activeTab === 'settings' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            الإعدادات
          </button>
        </div>

        {activeTab === 'actions' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              {actions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleAction(action?.id)}
                  className="p-4 rounded-lg border border-border hover:border-primary transition-all text-right group"
                >
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-lg flex items-center justify-center"
                      style={{ backgroundColor: `${action?.color}20` }}
                    >
                      <Icon name={action?.icon} size={20} color={action?.color} />
                    </div>
                    <span className="text-sm font-medium text-foreground group-hover:text-primary">
                      {action?.label}
                    </span>
                  </div>
                </button>
              ))}
            </div>

            <div className="bg-muted/50 rounded-lg p-4 space-y-3">
              <h3 className="text-sm font-semibold text-foreground flex items-center gap-2">
                <Icon name="Sparkles" size={16} />
                تحليلات الذكاء الاصطناعي
              </h3>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.aiInsights}
                    onChange={(e) => handleInputChange('aiInsights', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">رؤى وتوصيات ذكية</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.autoSchedule}
                    onChange={(e) => handleInputChange('autoSchedule', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">جدولة تلقائية شهرية</span>
                </label>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'templates' && (
          <div className="space-y-3">
            {templates?.map((template) => (
              <div
                key={template?.id}
                className="p-4 rounded-lg border border-border hover:border-primary transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h4 className="text-sm font-semibold text-foreground">{template?.name}</h4>
                    <p className="text-xs text-muted-foreground mt-1">
                      {template?.metrics?.join(', ')}
                    </p>
                  </div>
                  <Button variant="outline" size="sm">
                    إنشاء
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'settings' && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">نوع التقرير</label>
                <select
                  value={formData?.reportType}
                  onChange={(e) => handleInputChange('reportType', e?.target?.value)}
                  className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground"
                >
                  <option value="performance">أداء</option>
                  <option value="financial">مالي</option>
                  <option value="sales">مبيعات</option>
                  <option value="marketing">تسويق</option>
                </select>
              </div>
              <Input
                label="من تاريخ"
                type="date"
                value={formData?.dateFrom}
                onChange={(e) => handleInputChange('dateFrom', e?.target?.value)}
              />
              <Input
                label="إلى تاريخ"
                type="date"
                value={formData?.dateTo}
                onChange={(e) => handleInputChange('dateTo', e?.target?.value)}
              />
            </div>

            <div className="space-y-3">
              <h3 className="text-sm font-semibold text-foreground">خيارات التقرير</h3>
              <div className="space-y-2">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.includeCharts}
                    onChange={(e) => handleInputChange('includeCharts', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">تضمين الرسوم البيانية</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData?.includeAnalysis}
                    onChange={(e) => handleInputChange('includeAnalysis', e?.target?.checked)}
                    className="w-4 h-4 rounded border-border"
                  />
                  <span className="text-sm text-foreground">تضمين التحليل التفصيلي</span>
                </label>
              </div>
            </div>
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4 border-t border-border">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button variant="default">
            إنشاء التقرير
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReportsActionsModal;